export default __webpack_public_path__ + "static/media/people8.aa4a3ece.jpeg";